import EshopOrder from '../../eshopbootstrap/order';

export default class Order extends EshopOrder {

}
